module.exports = __webpack_public_path__ + "img/featureCRM.13b2f29.png";